import { AvatarSize } from 'components/core/avatar/AvatarSizes'
import { C1DisplayNameSkeleton, DisplayNameDetails, DisplayNameDetailsProps } from 'components/core/display-name-details'
import { MinimalAPIError } from 'components/core/errors/api'
import { ResourceTypeAvatar } from 'components/pages/entitlement/resource-type/icons'
import { AppResourceType } from 'pbts/c1/api/app/v1/app_resource'
import { FormattedMessage } from 'react-intl'
import { getAppEntitlementApi } from 'redux_toolkit/entitlements'

export type ResourceTypeDisplayNameProps = {
    resourceType: AppResourceType
    avatarSize?: AvatarSize
} & Omit<DisplayNameDetailsProps, 'avatar' | 'displayName'>

export const ResourceTypeDisplayName = ({
    resourceType,
    avatarSize = 'md',
    ...rest
}: ResourceTypeDisplayNameProps): React.ReactElement => {
    const avatar = <ResourceTypeAvatar resourceTypeName={resourceType.displayName} size={avatarSize} />
    // TODO: remove this after catalog => profile data migration is complete
    const displayName = resourceType.displayName.toLowerCase() === 'catalog' ? 'Access profile' : resourceType.displayName

    return (
        <DisplayNameDetails
            avatar={avatar}
            displayName={displayName}
            readOnly
            isDeleted={resourceType.deletedAt !== undefined}
            {...rest}
        />
    )
}

export type ResourceTypeDisplayNameWithEntitlementFetchProps = {
    entitlementId: string
    appId: string
} & Omit<ResourceTypeDisplayNameProps, 'resourceType'>

export const ResourceTypeDisplayNameWithEntitlementFetch = ({
    entitlementId,
    appId,
    ...resourceTypeDisplayNameProps
}: ResourceTypeDisplayNameWithEntitlementFetchProps): React.ReactElement | null => {
    const { data, error, isLoading } = getAppEntitlementApi.useGet({ appId, id: entitlementId, expandMask: { paths: ['*'] } })

    if (error) {
        const err = (
            <FormattedMessage id="component_api_error_resource_type" defaultMessage="Error fetching resource type" />
        )
        return <MinimalAPIError err={err} />
    }

    if (isLoading || !data || !data.appResourceType) {
        return <C1DisplayNameSkeleton />
    }

    return <ResourceTypeDisplayName resourceType={data.appResourceType} {...resourceTypeDisplayNameProps} />
}
